"use client";

import {
  VolumeHighIcon,
  VolumeOffIcon,
} from "@hugeicons-pro/core-stroke-rounded";
import type { FC } from "react";
import ControlIcon from "./ControlIcon";
import { ControlContainer, type ControlProps } from "./IconContainer";

type Props = ControlProps & {
  isMuted?: boolean;
  iconSize?: number;
};

const GameControlsMute: FC<Props> = ({
  isMuted = false,
  iconSize,
  ...props
}) => (
  <ControlContainer {...props}>
    <ControlIcon
      icon={isMuted ? VolumeOffIcon : VolumeHighIcon}
      size={iconSize}
    />
  </ControlContainer>
);

export { GameControlsMute };
